import React from "react";
import GoogleSignin from "../img/btn_google_signin_dark_pressed_web.png";
import { auth } from "../firebase";
import { GoogleAuthProvider, signInWithRedirect } from "firebase/auth";

const Welcome = () => {
    const googleSignIn = () => {
        const provider = new GoogleAuthProvider();
        signInWithRedirect(auth, provider);
    };

    return (
        <main className="welcome">
            <h2>Welcome to my Portfolio Chat Application</h2>
            <img src="/chat512.png" alt="Chat icon" width={200} height={200} />
            <p>Sign in with Google to chat with me.</p>
            <button className="sign-in">
                <img onClick={googleSignIn} src={GoogleSignin} alt="sign in with google" type="button" />
            </button>
        </main>
    );
};

export default Welcome;